import { useState } from "react";
import { FileDown, FileText, FileSpreadsheet } from "lucide-react";
import "./PartnerPortal.css";

const REPORTS = [
  { key: "api_usage", label: "API Usage Report",
    detail: "Per-key request counts, scopes, last-used timestamps." },
  { key: "webhook_activity", label: "Webhook Activity",
    detail: "Every delivery with status, attempts, HTTP response." },
  { key: "security", label: "Security Activity",
    detail: "Login, MFA, password, brute-force, key rotations." },
  { key: "audit", label: "Full Audit History",
    detail: "Every action taken by portal + admin users on your org." },
  { key: "integration_health", label: "Integration Health Snapshot",
    detail: "Current state of API + Auth + OAuth + Webhooks + Platform." },
];

const WINDOWS = [7, 30, 90];

export default function PartnerReports() {
  const [days, setDays] = useState(30);

  const download = (kind, format) => {
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/partner/portal/reports/${kind}.${format}`
      + `?window_days=${days}&_t=${Date.now()}`;
    // Use fetch to include Authorization header, then download blob
    const token = localStorage.getItem("hw_partner_access_token");
    fetch(url, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => {
        if (!r.ok) throw new Error("Download failed");
        const filename = (r.headers.get("Content-Disposition") || "")
          .match(/filename="([^"]+)"/)?.[1] || `${kind}.${format}`;
        return r.blob().then((b) => ({ blob: b, filename }));
      })
      .then(({ blob, filename }) => {
        const a = document.createElement("a");
        const url = URL.createObjectURL(blob);
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
      })
      .catch((e) => {
        alert(`Download failed: ${e.message || e}`);
      });
  };

  return (
    <div data-testid="pp-reports">
      <h1 className="hw-pp__page-title">
        <FileDown className="w-5 h-5"
                    style={{ display: "inline", verticalAlign: "text-bottom", marginRight: "0.4rem" }} />
        Reports &amp; Exports
      </h1>
      <p className="hw-pp__page-sub">
        Download reports as CSV (for spreadsheets/BI) or PDF (for archives and internal reviews).
        Everything is scoped to your organization.
      </p>

      <div className="hw-pp__panel">
        <h3>
          <span>Window</span>
          <small>Applies to time-scoped reports (all except API Usage &amp; Health snapshot)</small>
        </h3>
        <div style={{ display: "flex", gap: "0.35rem" }}>
          {WINDOWS.map((w) => (
            <button key={w}
                     className={`hw-pp__btn ${days === w ? "hw-pp__btn--primary" : ""}`}
                     onClick={() => setDays(w)}
                     data-testid={`pp-rep-window-${w}`}>
              {w} days
            </button>
          ))}
        </div>
      </div>

      {REPORTS.map((r) => (
        <div key={r.key} className="hw-pp__panel"
              data-testid={`pp-rep-${r.key}`}>
          <h3>
            <span>{r.label}</span>
            <div style={{ display: "flex", gap: "0.35rem" }}>
              <button className="hw-pp__btn" onClick={() => download(r.key, "csv")}
                       data-testid={`pp-rep-${r.key}-csv`}>
                <FileSpreadsheet className="w-3.5 h-3.5" /> CSV
              </button>
              <button className="hw-pp__btn hw-pp__btn--primary"
                       onClick={() => download(r.key, "pdf")}
                       data-testid={`pp-rep-${r.key}-pdf`}>
                <FileText className="w-3.5 h-3.5" /> PDF
              </button>
            </div>
          </h3>
          <div style={{ color: "#94A3B8", fontSize: "0.83rem" }}>{r.detail}</div>
        </div>
      ))}
    </div>
  );
}
